const createScriptTag = (scriptData) => {
  const attributes = Object.keys(scriptData);
  const element = document.createElement('script');
  attributes.forEach((attribute) => {
    element[attribute] = scriptData[attribute];
  });
  element.defer = true;
  return element;
};

export default createScriptTag;
